var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type == 'NSXV_BACKED')?_c('DetailV'):(_vm.type == 'NSXT_BACKED')?_c('DetailT'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }